import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit {

  logged: boolean;

  constructor() { }

  ngOnInit(): void {
    this.logged = localStorage.getItem('user') !== null;
  }
}
